var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarInterviewProcessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_8825)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.75,
    cy: 5.5,
    r: 1.5,
    stroke: "#424242",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 9,
    r: 1.5,
    stroke: "#424242",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5001H2M10.3963 12.5001H7.5M2 12.5001V11.75C2 10.2312 3.23122 9 4.75 9V9C6.26878 9 7.5 10.2312 7.5 11.75V12.5001M2 12.5001H7.5",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15V14.75C9.5 13.2312 10.7312 12 12.25 12V12C13.7688 12 15 13.2312 15 14.75V15",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5V5.7716C8.5 5.85878 8.60377 5.90421 8.66783 5.84508L9.58333 5H14.5C14.7761 5 15 4.77614 15 4.5V1.5C15 1.22386 14.7761 1 14.5 1H9C8.72386 1 8.5 1.22386 8.5 1.5Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_8825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarInterviewProcessIcon);
export default __webpack_public_path__ + "static/media/sidebar-interview-process-icon.5f885b9f8d3d447e8ed3f4cd4094137a.svg";
export { ForwardRef as ReactComponent };